import { render } from "./LicenseMainNoRequest.vue?vue&type=template&id=a999a162"
import script from "./LicenseMainNoRequest.vue?vue&type=script&lang=js"
export * from "./LicenseMainNoRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__